<template>
    <div>
        <fieldset>
            <legend>Dados Pessoais</legend>
			
			<div class="row">
                <div class="input-field col s5 m5 l5 xl5">
                    <input id="nome" type="text" readonly name="nome" v-model="user.name"/>
                    <label for="nome">Nome</label>
                </div>
                <div class="input-field col s2 m2 l2 xl2">
                    <input id="cpf" type="text" readonly name="cpf" v-model="user.cpf"/>
                    <label for="cpf">CPF</label>
                </div>
				<div class="input-field col s5 m5 l5 xl5">
                    <input id="nome_social" type="text" name="nome_social" readonly v-model="user.nome_social"/>
                    <label class='active' for="nome_social">Nome Social</label>
                </div>
				
			</div>
			
			<div class="row">
				
				<div class="input-field col s12 m6 l6 xl6">
                    <input id="centro" type="text" readonly name="centro" v-model="cen.nome"/>
                    <label for="centro">Centro</label>
                </div>
				<div class="input-field col s12 m6 l6 xl6">
                    <input id="unidade" type="text"  name="unidade" readonly v-model="uni.nome"/>
                    <label for="unidade">Unidade</label>
                </div>
			</div>
			
			<div class="row">
				<div class="input-field col s12 m9 l9 xl9">
                    <input id="localizacao" type="text" name="localizacao" readonly :value="loc.nome + ' - ' + loc.codigo"/>
                    <label class='active' for="localizacao">Localização</label>
                </div>
				<div class="input-field col s12 m3 l3 xl3">
                    <input id="lattes" type="text" name="lattes" readonly :value="user.lattes"/>
                    <label class='active' for="lattes">Lattes</label>
                </div>
			</div>
			<div class="row">
				<div class="input-field col s2 m2 l2 xl2">
                    <input id="email" type="email" readonly name="email" v-model="user.email"/>
                    <label for="email">Email</label>
                </div>
			</div>
			
        </fieldset>
		<fieldset>
            <legend>Dados Curriculares</legend>
				<div class="row">
					<div class="input-field col s2">
						<a :href="'/curriculos/lattes/pdf/' + user.id" class="btn" target='_blank'><i class="material-icons left">assignment_returned</i>Lattes</a>
					</div>
				</div>
				<fieldset>
					<legend>Atuação Artístico-Cultural</legend>
					<div class="row centered">
                        <table class="table-responsive highlight striped ">
                            <thead>
                                <th>#</th>
                                <th>Tipo de Atuação</th>
                                <th>Quantidade</th>
                                <th>PDF</th>
                            </thead>
                            <tbody>
                                <tr v-for="atuacao in this.filterAtuacaoArtisticaTable">
                                    <td>{{atuacao['id']}}
                                    <td>{{atuacao['nome']}}</td>
                                    <td>{{atuacao['quantidade']}}</td>
                                    <td v-if="atuacao['pdf']">
                                        <a :href="'/curriculos/atuacoes/pdf/' + atuacao['id']" class="btn" target='_blank'>
											<i class="material-icons left">assignment_returned</i>Visualizar PDF
										</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
				</fieldset>
				<fieldset>
					<legend>Produção Científica</legend>
					<div class="row centered">
                        <table class="table-responsive highlight striped ">
                            <thead>
                                <th>#</th>
                                <th>Tipo de Atuação</th>
                                <th>Quantidade</th>
                                <th>PDF</th>
                            </thead>
                            <tbody>
                                <tr v-for="atuacao in this.filterProducaoCientificaTable">
                                    <td>{{atuacao['id']}}
                                    <td>{{atuacao['nome']}}</td>
                                    <td>{{atuacao['quantidade']}}</td>
                                    <td v-if="atuacao['pdf']">
                                        <a :href="'/curriculos/atuacoes/pdf/' + atuacao['id']" class="btn" target='_blank'>
											<i class="material-icons left">assignment_returned</i>Visualizar PDF
										</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
				</fieldset>
				<fieldset>
					<legend>Atuação na SIAC</legend>
					<div class="row centered">
                        <table class="table-responsive highlight striped">
                            <thead>
                                <th>#</th>
                                <th>Tipo de Atuação</th>
                                <th>Quantidade</th>
                            </thead>
                            <tbody>
                                <tr v-for="atuacao in this.filterAtuacaoSIACTable">
									<td>{{atuacao['id']}}
									<td>{{atuacao['nome']}}</td>
									<td>{{atuacao['quantidade']}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
				</fieldset>
        </fieldset>
		
		<fieldset>
			<legend>Projetos</legend>
			<fieldset v-for="(proj, index) in prjs">
				<legend>Projeto {{index + 1}}</legend>
				<div class="row">
					<div class="input-field col s6">
						<input type="text" readonly v-model="proj['titulo']" name="titulo" />
						<label for="titulo" >Título do Projeto</labeL>
					</div>
					<div class="input-field col s2">
						<input type="text" readonly  class='mask-cnpq' name="area_cnpq" v-model="proj['area_cnpq']" />
						<label for="area_cnpq">Código de área do CNPQ</label>
					</div>
					<div class="input-field col s2">
						<a :href="'/projetos/pdf/' + proj['id']" class="btn" target='_blank'>
							<i class="material-icons left">assignment_returned</i><small>Projeto</small>
						</a>
					</div>
					<div class="input-field col s2">
						<a class="btn" :href="`/projetos/${proj.id}/memorialDownload`" target='_blank'>
							<i class="material-icons left">assignment_returned</i><small>Memorial</small>
						</a>
					</div>
				</div>
				
				<div class="row">
					<div class="input-field col s7">
						<input type="text" readonly v-model="proj['instancia']" name="instancia" id="instancia" maxlength="200"/>
						<label for="instancia">Instância que Aprovou o Projeto</labeL>
					</div>
					<div class="input-field col s2">
						<input type="date" ready v-model="proj['data_aprovacao']" name="data_aprovacao" id="data_aprovacao"/>
						<label for="data_aprovacao">Data da Aprovação</labeL>
					</div>
					<div class="input-field col s3">
						<a class="btn" :href="'/comprovante/pdf/' + proj.id" target='_blank'>
							<i class="material-icons left">assignment_returned</i><small>Comprovante</small>
						</a>
					</div>
				</div>
				
				<div class="row">
					<div class="input-field col s12">
						<textarea name="resumo" readonly v-model="proj['resumo']" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>
						<label for="resumo">Resumo</label>
					</div>
				</div>
				<div class="row">
					<div class="input-field col s4">
						<input type="text" readonly v-model="proj['palavras_chave']" name="palavras_chave" />
						<label for="palavras_chave">Palavras-Chave</label>
					</div>
					<div class="input-field col s1">
						<input type="text" name="numero_bolsas" readonly :value="proj['bolsas'].length"/>
						<label for="numero_bolsas">Bolsas</label> 
					</div>
					<div class="input-field col s7">
						<textarea name="justificativa" readonly v-model="proj['justificativa_bolsas']" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>
						<label for="justificativaDoNumeroDeBolsas">Justificativa de número de bolsas</label>
					</div>
				</div>
				<div class="row">
					<div v-for="(bolsa, idx) in proj.bolsas">
						<div class="input-field col s12">
							<label for="plano">Plano de trabalho para bolsa {{idx + 1}}</label>
							<textarea name="plano" readonly v-model="bolsa['plano_trabalho']" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>
						</div>
					</div>
				</div>
				<div v-for="(colab, i) in proj.colaboradores">
					<fieldset>
						<legend>Colaborador {{i + 1}}</legend>
							<div class="row">
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_cpf[' + i + ']'" v-model='colab.user.cpf' type="text" class="validate" readonly>
									<label class='active' :for="'col_cpf[' + i + ']'">CPF <small>(somente números)</small></label>
								</div>
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_nome[' + i + ']'" v-model='colab.user.name' type="text" disabled required>
									<label class='active' :for="'col_nome[' + i + ']'">Nome</label>
								</div>
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_email[' + i + ']'" v-model='colab.user.email' type="email" disabled required>
									<label class='active' :for="'col_email[' + i + ']'">E-mail</label>
								</div>
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_social[' + i + ']'" v-model='colab.user.nome_social' type="text" disabled>
									<label class='active' :for="'col_social[' + i + ']'">Nome social</label>
								</div>
							</div>
							<div class="row">
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_centro[' + i + ']'" v-model='colab.user.unidade.centro.nome' type="text" disabled required>
									<label class='active' :for="'col_centro[' + i + ']'">Centro</label>
								</div>
								<div class="input-field col s12 m3 l3 xl3">
									<input :name="'col_unidade[' + i + ']'" v-model='colab.user.unidade.nome' type="text" disabled required>
									<label class='active' :for="'col_unidade[' + i + ']'">Unidade</label>
								</div>
								<div class="file-field input-field col s12 m3 l3 xl3">
									<a :href="'/col-lattes/pdf/' + user.id + '/' + colab.user.cpf" class="btn" target='_blank'>
										<i class="material-icons left">assignment_returned</i>Visualizar PDF
									</a>
								</div>
							</div>
					</fieldset>
				</div>
			</fieldset>
		</fieldset>
		<div v-if="enviar == 'true'" class="input-field col s12 m12 l12 xl12">
			<center><a href='/projetos/enviar' class="btn indigo" onclick=' return confirmarEnvioPrj();'><i class="material-icons left">done_all</i>Enviar tudo</a></center>
		</div>
    </div>
</template>

<script>
    export default {
		name:"VueProjetoVisualizar",
		props:[
			'usuario',
			'projetos',        
			'colaboradores',
            'centro',
            'unidade',
			'localizacao',
			'atuacaos',
            "atuacoesusuario",
            "curriculo",
			"enviar"
    ],

    data(){
        return {
			user: JSON.parse(this.usuario),
			uni: JSON.parse(this.unidade),
            cen: JSON.parse(this.centro),
			loc: JSON.parse(this.localizacao),
			atuacoes: JSON.parse(this.atuacaos),
            atuacoesUsuario: JSON.parse(this.atuacoesusuario),
			prjs: JSON.parse(this.projetos),
			env: this.enviar
        }
    },
    computed: { 
		filterAtuacaoArtisticaTable:function(){
			if(this.atuacoesUsuario)
				return this.atuacoesUsuario.filter((atuacao)=>{
					var atua=this.getAtuacao(atuacao['atuacao_id']);
					atuacao.nome = atua.nome;
					if (atua['tipo'] == 'artístico-cultural')
						return atua;					 
				});
		},
		filterProducaoCientificaTable:function(){
			if(this.atuacoesUsuario)
				return this.atuacoesUsuario.filter((atuacao)=>{
					var atua=this.getAtuacao(atuacao['atuacao_id']);
					atuacao.nome = atua.nome;
					if (atua['tipo'] == 'produção científica')
						return atua;					 
				});
		},
		filterAtuacaoSIACTable:function(){
			if(this.atuacoesUsuario)
				return this.atuacoesUsuario.filter((atuacao)=>{
					var atua=this.getAtuacao(atuacao['atuacao_id']);
					atuacao.nome = atua.nome;
					if (atua['tipo'] == 'SIAC') 
						return atua;
				});
		}
    },
	
	
    methods: {
		getIdAtuacao(nomeAtuacao){
           return this.atuacoes.find( ({nome}) =>
                nome == nomeAtuacao
            );
        },
		getAtuacao(idAtuacao){
            return (this.atuacoes.find( ({id}) =>
                id == idAtuacao
            ));
        },
	
    },
    mounted(){
		if (!this.user.nome_social)
			this.user.nome_social = ' ';
		if (!this.user.lattes)
			this.user.lattes = ' ';	
    },
    ready(){
    },
}
</script>
 